<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loadingPlan" opacity="0.99">
        <div class="row">
          <div class="col-md-12">
            <v-btn class="v-primary" @click="$router.go(-1)">
              <span class="fa fa-arrow-left"></span> Voltar
            </v-btn>
          </div>
          <div class="col-md-4">
            <h3>
              <span class="text-muted">Plano:</span>
              {{ plan.description }}
            </h3>
            <h6>
              <span class="text-muted">Criação:</span>
              {{ formatDate(plan.created_at) }}
            </h6>
            <h6>
              <span class="text-muted">Última alteração:</span>
              {{ formatDate(plan.updated_at) }}
            </h6>
          </div>

          <div class="col-md-8">
            <form v-on:submit="update" method="post">
              <div class="row">
                <WarningRequiredFields />
                <ErrorsMessages :errors="errors" />
                <div class="col-md-12">
                  <LabelRequiredField label="Descrição" />
                  <input
                    :disabled="!permissions.plans.edit"
                    type="text"
                    v-model="description"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <LabelRequiredField label="Sempre cobrar por residente" />
                  <b-checkbox
                    v-model="force_charge_per_resident"
                    :value="1"
                    :unchecked-value="0"
                  >
                    {{ force_charge_per_resident ? "SIM" : "NÃO" }}
                  </b-checkbox>
                </div>
                <div class="col-md-3">
                  <LabelRequiredField label="Valor até 10 residentes" />
                  <input
                    :disabled="!permissions.plans.edit"
                    type="text"
                    v-model="value_up_to"
                    v-on:keyup="handleValueUpTo"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <LabelRequiredField label="Valor por residente" />
                  <input
                    :disabled="!permissions.plans.edit"
                    type="text"
                    v-model="value_per"
                    v-on:keyup="handleValuePer"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <LabelRequiredField label="Prazo de pagamento" />
                  <b-select v-model="payment_term_id">
                    <b-select-option value>ESCOLHA</b-select-option>
                    <b-select-option
                      v-for="item in payment_terms"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </b-select-option>
                  </b-select>
                </div>
                <div class="col-md-12 text-right">
                  <v-btn
                    v-if="permissions.plan_has_module.write"
                    class="v-secondary m-1"
                    @click="
                      errors = [];
                      $bvModal.show('createPlanHasModule');
                    "
                  >
                    <span class="fa fa-plus"></span> Vincular módulo
                  </v-btn>
                  <!-- Modal vincular módulo -->
                  <b-modal id="createPlanHasModule" hide-footer>
                    <template v-slot:modal-title>Vincular módulo</template>
                    <div class="d-block">
                      <div class="container">
                        <form v-on:submit="createPlanHasModule" method="post">
                          <div class="row">
                            <ErrorsMessages :errors="errors" />
                            <div class="col-md-12">
                              <label>Módulo</label>
                              <select v-model="idModule" class="form-control">
                                <option value>Selecione...</option>
                                <option
                                  v-for="value in modules"
                                  :key="value.id"
                                  :value="value.id"
                                >
                                  {{ value.description }}
                                </option>
                              </select>
                            </div>
                            <div class="col-md-12 text-right">
                              <v-btn
                                :disabled="loadingCreatePlanHasModule"
                                type="submit"
                                class="v-success"
                              >
                                <span class="fa fa-check"></span>
                                {{
                                  loadingCreatePlanHasModule
                                    ? "Carregando"
                                    : "Salvar"
                                }}
                              </v-btn>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </b-modal>
                  <!-- /Modal vincular módulo -->
                  <v-btn
                    v-if="permissions.plans.edit"
                    :disabled="loadingUpdate"
                    type="submit"
                    class="m-1 v-success"
                  >
                    <span class="fa fa-check"></span>
                    {{ loadingUpdate ? "Carregando" : "Salvar" }}
                  </v-btn>
                </div>
              </div>
            </form>
          </div>

          <div class="col-md-12">
            <b-overlay :show="loadingPlanHasModule" opacity="0.99">
              <v-card>
                <v-card-title>
                  Módulos
                  <v-spacer />
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  />
                </v-card-title>
                <v-data-table
                  dense
                  :headers="headers"
                  :items="planHasModules"
                  :search="search"
                  class="elevation-1"
                  :footer-props="{
                    'items-per-page-options': [25, 75, 100],
                    'items-per-page-text': 'Mostrar',
                  }"
                  @click:row="handleClickRowTable"
                >
                  <template v-slot:[`item.value_up_to`]="{ item }">{{
                    formatPrice(item.value_up_to)
                  }}</template>
                  <template v-slot:[`item.value_per`]="{ item }">{{
                    formatPrice(item.value_per)
                  }}</template>
                  <template v-slot:[`item.edit`]="{ item }">
                    <!-- Modal alterar módulo -->
                    <b-modal :id="String(item.id)" hide-footer>
                      <template v-slot:modal-title>Editar módulo</template>
                      <div class="d-block">
                        <div class="container">
                          <b-overlay :show="loadingModuleUpdate" opacity="0.99">
                            <form v-on:submit="updateModule" method="post">
                              <div class="row">
                                <div class="col-md-6">
                                  <LabelRequiredField
                                    label="Valor até 10 residentes"
                                  />
                                  <input
                                    :disabled="!permissions.modules.edit"
                                    type="text"
                                    v-model="valueModuleUpTo"
                                    v-on:keyup="handleValueModuleUpTo"
                                    class="form-control"
                                  />
                                </div>
                                <div class="col-md-6">
                                  <LabelRequiredField
                                    label="Valor por residente"
                                  />
                                  <input
                                    :disabled="!permissions.modules.edit"
                                    type="text"
                                    v-model="valueModulePer"
                                    v-on:keyup="handleValueModulePer"
                                    class="form-control"
                                  />
                                </div>
                                <div class="col-md-12">
                                  <WarningRequiredFields />
                                  <ErrorsMessages :errors="errors" />
                                </div>
                                <div class="col-md-12 text-right">
                                  <v-btn
                                    class="v-primary m-1"
                                    @click="$bvModal.hide(String(item.id))"
                                  >
                                    <span class="fa fa-arrow-left"></span>
                                    Voltar
                                  </v-btn>
                                  <v-btn
                                    v-if="permissions.modules.remove"
                                    class="v-danger m-1"
                                    v-confirm="{
                                      loader: false,
                                      ok: (dialog) =>
                                        deleteModule(dialog, item),
                                      cancel: () => {},
                                      message:
                                        'Deseja realmente remover o módulo do plano',
                                      okText: 'Confirmar',
                                      cancelText: 'Cancelar',
                                    }"
                                  >
                                    <span class="fa fa-times-circle"></span>
                                    Remover
                                  </v-btn>
                                  <v-btn
                                    v-if="permissions.modules.edit"
                                    :disabled="loadingUpdateModule"
                                    type="submit"
                                    class="v-success m-1"
                                  >
                                    <span class="fa fa-check"></span>
                                    {{
                                      loadingUpdateModule
                                        ? "Carregando"
                                        : "Salvar"
                                    }}
                                  </v-btn>
                                </div>
                              </div>
                            </form>
                          </b-overlay>
                        </div>
                      </div>
                    </b-modal>
                    <!-- /Modal alterar módulo -->
                  </template>
                </v-data-table>
              </v-card>
              <hr />
              <v-card>
                <v-card-text>
                  <h5 class="text-dark">Total módulos</h5>
                  <h6>
                    <span>Valor até 10 residentes:</span>
                    <span class="text-dark">{{
                      formatPrice(totalValuesUpTo)
                    }}</span>
                  </h6>
                  <h6>
                    <span>Valor por residente:</span>
                    <span class="text-dark">{{
                      formatPrice(totalValuesPer)
                    }}</span>
                  </h6>
                  <h5 class="text-dark">Total</h5>
                  <h6>
                    <span>Valor até 10 residentes:</span>
                    <span class="text-dark">{{
                      formatPrice(totalValuesUpTo + plan.value_up_to)
                    }}</span>
                  </h6>
                  <h6>
                    <span>Valor por residente:</span>
                    <span class="text-dark">{{
                      formatPrice(totalValuesPer + plan.value_per)
                    }}</span>
                  </h6>
                </v-card-text>
              </v-card>
            </b-overlay>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import routes from "../routes";
import api from "../services/api";
import toast from "../components/ToastNotification";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatDate,
} from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "Plan",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],

      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Módulo", value: "description_module" },
        { text: "Valor até 10 residentes", value: "value_up_to" },
        { text: "Valor por residentes", value: "value_per" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      plan: {},

      force_charge_per_resident: 0,
      planHasModules: [],
      payment_terms: [],
      payment_term_id: "",
      modules: [],
      idModule: "",
      id: "",
      description: "",
      value_up_to: "",
      value_per: "",
      loadingPlan: true,
      loadingPlanHasModule: true,
      loadingUpdate: false,
      loadingUpdateModule: false,
      loadingModuleUpdate: false,
      loadingCreatePlanHasModule: false,
      idPlanHasModule: "",
      valueModuleUpTo: "",
      valueModulePer: "",
      totalValuesUpTo: 0,
      totalValuesPer: 0,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatPrice,
    formatValueOnKeyUp,
    formatDate,

    handleClickRowTable(item) {
      this.errors = [];
      this.handleModalModule(item.id);
      this.$bvModal.show(String(item.id));
    },

    handleValueUpTo: function (e) {
      this.value_up_to = formatValueOnKeyUp(e.target.value);
    },

    handleValuePer: function (e) {
      this.value_per = formatValueOnKeyUp(e.target.value);
    },

    handleValueModuleUpTo: function (e) {
      this.valueModuleUpTo = formatValueOnKeyUp(e.target.value);
    },

    handleValueModulePer: function (e) {
      this.valueModulePer = formatValueOnKeyUp(e.target.value);
    },

    async retrieve() {
      this.permissions = adminData().permissions;

      const { id } = routes.history.current.params;

      if (!id) {
        routes.push({ name: "plans" });
      }

      this.id = id;
      await this.getPaymentTerms();
      await this.getModules();
      await this.getPlan(id);
      await this.getPlanHasModule(id);
    },

    async getPlan(id) {
      try {
        this.loadingPlan = true;

        const response = await api.get("/admin/plan/get", { params: { id } });

        const { plan } = response.data;

        this.plan = plan;
        this.description = plan.description;
        this.value_up_to = formatPrice(plan.value_up_to);
        this.value_per = formatPrice(plan.value_per);
        this.payment_term_id = plan.payment_term_id;
        this.force_charge_per_resident = plan.force_charge_per_resident;
        this.loadingPlan = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getPlanHasModule(plan_id) {
      try {
        this.loadingPlanHasModule = true;

        const response = await api.get("/admin/plan/planHasModule/get", {
          params: { plan_id },
        });

        const { planHasModules, totalValuesUpTo, totalValuesPer } =
          response.data;

        this.planHasModules = planHasModules;
        this.totalValuesUpTo = totalValuesUpTo;
        this.totalValuesPer = totalValuesPer;
        this.loadingPlanHasModule = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getModules() {
      try {
        const response = await api.get("/admin/modules");
        const { modules } = response.data;

        this.modules = modules;
      } catch (error) {
        console.log(error);
      }
    },

    async getPaymentTerms() {
      try {
        this.loading = true;

        let response = await api.get("/admin/plans/payment-terms");
        let { error, errors, payment_terms } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.payment_terms = payment_terms;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async update(event) {
      event.preventDefault();
      this.loadingUpdate = true;

      try {
        const {
          id,
          description,
          value_up_to,
          value_per,
          payment_term_id,
          force_charge_per_resident,
        } = this;

        let params = {
          id,
          description,
          value_up_to,
          value_per,
          payment_term_id,
          force_charge_per_resident,
        };

        const response = await api.put("/admin/plan/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.getPlan(id);
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async createPlanHasModule(event) {
      event.preventDefault();
      this.loadingCreatePlanHasModule = true;

      try {
        const { id, idModule } = this;
        let params = {
          plan_id: id,
          module_id: idModule,
        };

        const response = await api.post("/admin/planHasModule/create", params);
        const { error, errors, message } = response.data;
        if (!error) {
          this.$bvModal.hide("createPlanHasModule");
          this.getPlanHasModule(id);
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreatePlanHasModule = false;
      } catch (error) {
        console.log(error);
      }
    },

    async updateModule(event) {
      try {
        event.preventDefault();

        this.loadingUpdateModule = true;

        const { id, idPlanHasModule, valueModuleUpTo, valueModulePer } = this;

        let params = {
          id: idPlanHasModule,
          value_up_to: valueModuleUpTo,
          value_per: valueModulePer,
        };

        const response = await api.put("/admin/planHasModule/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(String(idPlanHasModule));
          this.getPlanHasModule(id);
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdateModule = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleModalModule(id) {
      try {
        this.loadingModuleUpdate = true;

        this.idPlanHasModule = id;

        const response = await api.get("/admin/planHasModule/get", {
          params: { id },
        });

        const { planHasModule } = response.data;

        this.valueModuleUpTo = formatPrice(planHasModule.value_up_to);
        this.valueModulePer = formatPrice(planHasModule.value_per);
        this.loadingModuleUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteModule(dialog, planHasModule) {
      try {
        const { plan_id, module_id } = planHasModule;

        let data = { plan_id, module_id };

        const response = await api.delete("/admin/planHasModule/delete", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.getPlanHasModule(this.id);
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>